/**
 * Metric Card Component
 * Displays a payment metric with title, value, and optional subtitle
 */

interface MetricCardProps {
  title: string;
  value: number;
  subtitle?: string;
  color?: 'success' | 'warning' | 'error';
}

const colorMap = {
  success: 'border-l-success',
  warning: 'border-l-warning',
  error: 'border-l-destructive',
};

export function MetricCard({ title, value, subtitle, color = 'success' }: MetricCardProps) {
  const accentClass = colorMap[color];

  return (
    <div className={`bg-card rounded-lg p-5 border border-border border-l-4 ${accentClass}`}>
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide m-0">
        {title}
      </h3>
      <div className="text-3xl font-bold text-foreground mt-2">
        ${(value / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </div>
      {subtitle && (
        <p className="text-sm text-muted-foreground mt-1 m-0">
          {subtitle}
        </p>
      )}
    </div>
  );
}
